import styled from 'styled-components';
import WidgetContent from 'app/components/atoms/WidgetContent/WidgetContent';

const CardContent = styled(WidgetContent)`
    font-size: inherit;
    padding: 0;
`;

export default CardContent;
